import React from "react";
import ShoppingBasketRoundedIcon from "@mui/icons-material/ShoppingBasketRounded";

const Ticket = ({ lottoryNumber, noLottery, onPickUp, onPickOff }) => {
  const [pick, setPick] = React.useState(false);
  const [reversePick, setReversePick] = React.useState(false);
  const [listPickup, setList] = React.useState([]);

  const NumberItem = ({ number }) => {
    return (
      <p className="text-[#b3853e] border border-[#b3853e] bg-white rounded-full text-3xl w-9 h-9 md:text-2xl md:h-8 md:w-8">
        {number}
      </p>
    );
  };

  const setData = () => {
    const data = {
      betAmount: 1,
      currency: "credit",
      lotteryNumber: lottoryNumber,
      lotteryRound: localStorage.getItem("roundId"),
      lotteryType: "bon_6",
      member: null,
    };
    onPickUp(data);
    setPick(true);
  };

  let findPermutations = (string) => {
    let permutationsArray = [];
    if (string.length < 2) return string;
    for (let i = 0; i < string.length; i++) {
      let char = string[i];
      if (string.indexOf(char) != i) continue;
      let remainingChars = string.slice(0, i) + string.slice(i + 1, string.length);
      for (let permutation of findPermutations(remainingChars)) {
        permutationsArray.push(char + permutation);
      }
    }
    return permutationsArray;
  };

  const setDataReverse = () => {
    const allNumber = findPermutations(lottoryNumber);

    allNumber.map((num, i) => {
      let data = {
        betAmount: 1,
        currency: "credit",
        lotteryNumber: num,
        lotteryRound: localStorage.getItem("roundId"),
        lotteryType: "bon_6",
        member: null,
      };
      onPickUp(data);
      setPick(true);
      setReversePick(true);
    })
  }

  const pickOffDataReverse = () => {
    const allNumber = findPermutations(lottoryNumber);

    allNumber.map((num, i) => {
      onPickOff(num);
      setPick(false);
      setReversePick(false)
    })
  }

  React.useEffect(() => {
    // console.log("test",setCountLotteryPickup);
    let temp = JSON.parse(
      localStorage.getItem(localStorage.getItem("lotteryId"))
    );
    setList(temp);
    if (temp.find((data) => data.lotteryNumber == lottoryNumber)) {
      setPick(true);
    }
  }, []);

  return (
    <div className="bg-[#f8eede] rounded shadow shadow-[#b3853e]">
      <div className="text-[#b3853e] py-1 px-1">
        <div className="grid grid-cols-8 gap-1 place-items-center rounded-md">
          <div className="col-span-6">
            <div className="flex gap-1">
              {lottoryNumber?.split("")?.map((data, i) => {
                return <NumberItem key={i} number={data} />;
              })}
            </div>
            <div className="text-left font-normal text-sm mt-2">
              <p className="font-bold">เงินรางวัล {localStorage.getItem("lotteryName") == 'หวย JACKPOT 6 ตัว' ? '400,000' : '300,000'} บาท</p>
            </div>
          </div>


          <div className="col-span-2 flex-row">
            {pick ? (
              <button
                className="rounded text-base bg-[#f8eede] text-[#b3853e] border border-[#b3853e] px-3 py-1"
                onClick={() => {
                  onPickOff(lottoryNumber);
                  setPick(false);
                }}
              >
                นำออก
              </button>
            ) : (
              <button
                className="rounded-md text-base bg-[#b3853e] text-[#f8eede] border border-[#b3853e] px-4 py-1"
                onClick={() => setData()}
              >
                เลือก
              </button>
            )}
            {/* {reversePick ? (
              <button
                className="rounded text-base bg-[#f8eede] text-[#b3853e] border border-[#b3853e] px-3 py-1 mt-0.5"
                onClick={() => pickOffDataReverse()}
              >
                นำออก
              </button>
            ) : (
              <button
                className="rounded-md text-base bg-[#b3853e] text-[#f8eede] border border-[#b3853e] px-1.5 py-1 mt-0.5"
                onClick={() => setDataReverse()}
              >
                กลับเลข
              </button>
            )} */}
          </div>
        </div>


      </div>
    </div>
  );
};

const TicketCard = ({
  dataLotteryFromSeach,
  onPickUp,
  onPickOff,
  newLotterySearch,
}) => {
  // console.log("dataLotteryFromSeach", dataLotteryFromSeach)
  return (
    <>
      <div className="grid grid-cols md:grid-cols-3 gap-2 md:px-10 pt-1 pb-5 px-1">
        {dataLotteryFromSeach?.map((data, i) => {
          return (
            <Ticket
              key={i}
              lottoryNumber={data.number}
              noLottery={data.noLottery}
              onPickUp={onPickUp}
              onPickOff={onPickOff}
            />
          );
        })}
      </div>
      {dataLotteryFromSeach.length >= 16 ? (
        <button
          className="w-full border-2 border-[#b3853e] py-2 text-[#b3853e]"
          onClick={() => newLotterySearch()}
        >
          โหลดเพิ่ม
        </button>
      ) : (
        <></>
      )}
    </>
  );
};

export default TicketCard;
